/* eslint-disable
    func-names,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
    prefer-rest-params,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const moduleDeps = [
  require('data/util').name,
  require('data/model/ledger').name,
  require('data/collection/ledgerCategory').name,
];

const _ = require('lodash');

const ledgerCollectionDeps = ['Collection', 'Ledger', 'LedgerCategoryCollection'];

const ledgerCollection = function (Collection, Ledger, LedgerCategoryCollection) {
  let LedgerCollection;
  return (LedgerCollection = (function () {
    LedgerCollection = class LedgerCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$$cacheModels = true;
        this.prototype.$resource = 'ledgeraccount';
        this.prototype.$type = Ledger;
      }
      $url() {
        return `${super.$url()}/client/${this.$storeId()}`;
      }

      getNameById(id) {
        return __guard__(this.$findById(id), x => x.name);
      }

      getSelectableLedgerAccounts() {
        return this.data.filter(ledger => ledger.canBeEdited);
      }

      getAccounts() {
        return this.data.filter(ledger => ledger.role);
      }

      getLedgers() {
        return this.data.filter(ledger => !ledger.role);
      }

      getAddOnLedgers() {
        return this.data.filter(ledger => ledger.isAddOn);
      }

      $getLedgersByCategory() {
        return _.groupBy(this.data, 'categoryId');
      }

      $aceId() {
        return __guard__(this.$find({ code: '5680' }), x => x.id);
      }

      $acrId() {
        return __guard__(this.$find({ code: '4500' }), x => x.id);
      }

      $init() {
        super.$init(...arguments);

        this.status = {};

        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }
    };
    LedgerCollection.initClass();
    return LedgerCollection;
  })());
};

ledgerCollection.$inject = ledgerCollectionDeps;

module.exports = angular
  .module('bench.data.collection.ledger', moduleDeps)
  .factory('LedgerCollection', ledgerCollection);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
